import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import exportLimit from "../../common/export-limit.vue";
import reportingService from "./reporting-service";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      quickSearch: false,
      detailSearch: false,
      selectedType: "1",
      isFormValid: false,
      typeList: [
        { Name: "Equals To", Pass: "1" },
        { Name: "Contains", Pass: "2" },
      ],
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      isAllProjectSelected: false,
      runDisabled: true,
      isAllBusinessSelected: false,
      isAllWarehouseSelected: false,
      isAllOrderTypeSelected: false,
      isAllParentClassSelected: false,
      isAllClassSelected: false,
      showStartDate: true,
      startDate: false,
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date(new Date().getTime() - 86400000).toISOString().split("T")[0],
      showData: false,
      pageUrl: "",
      exportDialog: false,
      route: "",
      showAdd: false,
      refresh: true,
      endDate: false,
      showEndDate: true,
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      projectList: [],
      partResultList: [],
      reportData: [],
      warehouseList: [],
      orderTypeList: [],
      page: 1,
      businessList: [],
      parentClassList: [],
      classList: [],
      shipMethodList: [],
      debouncedGetPartList: [],
      required: [(v) => parseInt(v) >= 0 || "Field is required"],
      max3Rule: [(v) => (v || "").length >= 3 || "Min Length of 3 character", (v) => (v || "").length > 0 || "Min Length of 3 character"],
      detailSearchString: "",
      showPart: true,
      hideSpecific: false,
      disableAll: false,
      specificSelected: false,
      disableSpecific: false,
      showPartNumDetails: false,
      showPartDetails: false,
      requiredText: [(v) => (Array.isArray(v) && v.length > 0) || "Field is required"],
      partNum: "",
      partSearchKey: "",
      totalRecords: 0,
      totalPages: 0,
      partDesc: "",
      reportObj: {
        execution_type: 1,
        search_so: "",
        proj_key: "",
        bu_key: "",
        ware_key: "",
        parent_class_key: "",
        class_key: "",
        lcsdate: new Date().toISOString().substr(0, 10),
        lcedate: new Date(new Date().getTime()).toISOString().substr(0, 10),
        user_id: EncryptUtility.localStorageDecrypt("userID"),
        order_type: "",
        serialized: false,
        page_number: 1,
        export: 0,
        filter_user_key: 0,
      },
      json_fields: {
        Project: "Project",
        Business: "Business",
        "SO Number": "SO_Number",
        "Line No": "Line_No",
        "Line Type": "Line_Type",
        "Order Type": "Order_Type",
        RMA: "RMA",
        "Cust Po": "Cust_PO",
        "Order No": "Order_No",
        "Origin Number": "Origin_Number",
        "Origin SO RMA": "Origin_SORMA",
        "Origin PO RMA": "Origin_PORMA",
        "Created Date": "Created_Date",
        "ShipBy Date": "ShipBy_Date",
        "Aloc Date": "Aloc_Date",
        "Shpd Date": "Shpd_Date",
        "Company Name": "Company_Name",
        Addr1: "Addr1",
        Addr2: "Addr2",
        City: "City",
        State: "State",
        "Zip Code": "Zip_Code",
        Country: "Country",
        Name: "Name",
        Email: "Email",
        "Empl Name": "Empl_Name",
        Empl_ID: "Empl_ID",
        Empl_Email: "Empl_Email",
        Cost_Center: "Cost_Center",
        SIte: "Site",
        Item: "Item",
        "OEM Part": "OEM_PartNo",
        Description: "Description",
        Model: "Model",
        PClass: "PClass",
        Class: "Class",
        OEM: "OEM",
        Price: "Price",
        "Qty Ord": "Qty_Ord",
        "Qty Ship": "Qty_Ship",
        BCN: "BCN",
        "Serial No": "Serial_No",
        ESN: "ESN",
        ICCID: "ICCID",
        "RLP ID": "RLP_ID",
        "Main ID": "Main_ID",
        Warranty: "Warranty",
        Grade: "Grade",
        Carrier: "Carrier",
        "Frt Bill": "Frt_bill",
        "Rtn Bill": "Rtn_bill",
        "Expect Rtn SN": "Expect_Rtn_SN",
        Location: "Location",
        Warehouse: "Warehouse",
        "Flex Code1": "flex_code1",
        "Flex Date1": "flex_data1",
        "Flex Code2": "flex_code2",
        "Flex Date2": "flex_data2",
        "Flex Code3": "flex_code3",
        "Flex Date3": "flex_data3",
        "Flex Code4": "flex_code4",
        "Flex Date4": "flex_data4",
        "Flex Code5": "flex_code5",
        "Flex Date5": "flex_data5",
      },
      reportHeader: [
        {
          text: "Project",
          align: "start",
          value: "Project",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Business",
          value: "Business",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "SO Number",
          value: "SO_Number",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Line No",
          value: "Line_No",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Line Type",
          value: "Line_Type",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Order Type",
          value: "Order_Type",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "RMA",
          value: "RMA",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Created Date",
          value: "Created_Date",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "ShipBy Date",
          value: "ShipBy_Date",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Aloc Date",
          value: "Aloc_Date",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Shpd Date",
          value: "Shpd_Date",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Company Name",
          value: "Company_Name",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Item",
          value: "Item",
          class: "primary customwhite--text",
          width: "150px",
        },
        {
          text: "Description",
          value: "Description",
          class: "primary customwhite--text",
          width: "150px",
        },
        {
          text: "Class",
          value: "Class",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Qty Ord",
          value: "Qty_Ord",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Qty Ship",
          value: "Qty_Ship",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "BCN",
          value: "BCN",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Serial No",
          value: "Serial_No",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Carrier",
          value: "Carrier",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Frt Bill",
          value: "Frt_bill",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Rtn Bill",
          value: "Rtn_bill",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Location",
          value: "Location",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Warehouse",
          value: "Warehouse",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Main ID",
          value: "Main_ID",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Warranty",
          value: "Warranty",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Grade",
          value: "Grade",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Method",
          value: "Method",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Origin No",
          value: "Origin_No",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Origin RMA",
          value: "Origin_rma",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Date Rcvd",
          value: "Date_Rcvd",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Code1",
          value: "flex_code1",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Data1",
          value: "flex_data1",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Code2",
          value: "flex_code2",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Data2",
          value: "flex_data2",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Code3",
          value: "flex_code3",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Data3",
          value: "flex_data3",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Code4",
          value: "flex_code4",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Data4",
          value: "flex_data4",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Code5",
          value: "flex_code5",
          class: "primary customwhite--text",
          width: "10%",
        },
        {
          text: "Flex Data5",
          value: "flex_data5",
          class: "primary customwhite--text",
          width: "10%",
        },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.debouncedGetPartList = Utility.debounce(this.getPartList, 500);
    this.getProjectData();
    this.finalReportObj = JSON.parse(JSON.stringify(this.reportObj));
  },
  computed: {
    processedProjectList() {
      return this.createProcessedList(this.projectList, this.isAllProjectSelected, "value_id", 0);
    },
    processedBusinessList() {
      return this.createProcessedList(this.businessList, this.isAllBusinessSelected, "bu_key", 0);
    },
    processedWarehouseList() {
      return this.createProcessedList(this.warehouseList, this.isAllWarehouseSelected, "ware_key", 0);
    },
    processedOrderTypeList() {
      return this.createProcessedList(this.orderTypeList, this.isAllOrderTypeSelected, "value_id", "ALL");
    },
    processedParentClassList() {
      return this.createProcessedList(this.parentClassList, this.isAllParentClassSelected, "parent_class_key", 0);
    },
    procressedClassList() {
      return this.createProcessedList(this.classList, this.isAllClassSelected, "class_key", 0);
    },
    lceDateFormattedMomentjs() {
      return this.reportObj.lcedate ? moment(String(this.reportObj.lcedate)).format("MM/DD/YYYY") : "";
    },
    lcsDateFormattedMomentjs() {
      return this.reportObj.lcsdate ? moment(this.reportObj.lcsdate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
    excelFileName() {
      return Utility.excelFileName("Shipment Activity");
    },
  },
  methods: {
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    async getProjectData() {
      this.projectList = [];
      let projectData = await reportingService.getReportingGenericProjectList("get", this.userId);
      if (projectData !== undefined && projectData !== null) {
        this.projectList = projectData;
      } else {
        this.projectList = [];
      }
    },
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter?.length == 1 ? true : false;
      } else return false;
    },
    onClickAll() {
      this.hideSpecific = true;
      this.reportObj.part_num = "0";
    },
    createProcessedList(list, isAllSelected, idKey = "value_id", allValueId = 0) {
      return (
        list?.map((item) => ({
          ...item,
          disabled: isAllSelected && item[idKey] !== allValueId,
        })) || []
      );
    },

    /**
     * Handles the common logic for multi-select components where an "ALL" option exists.
     * Updates the corresponding reportObj key and the isAllSelected flag.
     * @param {Array} selectedKeys - The array of selected keys from the component.
     * @param {string} reportObjKey - The key in this.reportObj to update (e.g., 'proj_key').
     * @param {string} isAllSelectedFlagKey - The key in this data for the boolean flag (e.g., 'isAllProjectSelected').
     * @param {number|string} [allValueId=0] - The value representing the "ALL" option.
     */
    handleSelectionChange(selectedKeys, reportObjKey, isAllSelectedFlagKey, allValueId = 0) {
      const userSelectedAll = selectedKeys.includes(allValueId);
      const wasOnlyAllSelected = this[isAllSelectedFlagKey]; // Get previous state
      if (userSelectedAll) {
        if (!wasOnlyAllSelected || selectedKeys?.length > 1) {
          this.reportObj[reportObjKey] = [allValueId];
        }
        this[isAllSelectedFlagKey] = true;
      } else {
        this[isAllSelectedFlagKey] = false;
      }
    },
    onChangeProject(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "proj_key", "isAllProjectSelected", 0);
      this.businessList = [];
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.bu_key = [];
      this.reportObj.ware_key = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.reportObj.order_type = [];
      this.specificSelected = false;
      this.showPart = true;
      this.isAllBusinessSelected = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.isAllOrderTypeSelected = false;
      this.reportObj.asset = "";
      this.reportData = [];
      this.totalRecords = 0;
      this.isAllClassSelected = false;
      this.clearPartShip();
      let businessObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
      };
      let orderTypeObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
      };
      if (this.reportObj.proj_key && this.reportObj.proj_key?.length > 0) {
        this.getBusinessData(businessObj);
        this.getOrderTypeData(orderTypeObj);
      }
      this.showData = false;
      this.disableAll = false;
      this.hideSpecific = false;
    },
    async getOrderTypeData(orderTypeObj) {
      this.orderTypeList = [];
      let orderTypeData = await reportingService.getReportingGenericOrderTypeList("post", orderTypeObj);
      if (orderTypeData && Array.isArray(orderTypeData)) {
        this.orderTypeList = orderTypeData;
      } else {
        this.orderTypeList = [];
      }
    },
    async getBusinessData(businessObj) {
      this.businessList = [];
      let businessData = await reportingService.getReportingGenericBusinessList("post", businessObj);
      if (businessData && Array.isArray(businessData)) {
        this.businessList = businessData;
      } else {
        this.businessList = [];
      }
    },
    onChangeBusiness(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "bu_key", "isAllBusinessSelected", 0);
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.ware_key = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.disableAll = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.isAllClassSelected = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.showPart = true;
      this.clearPartShip();
      // Prepare and call the next API
      let warehouseObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.bu_key && this.reportObj.bu_key?.length > 0) {
        this.getWarehouseData(warehouseObj);
      }
    },
    async getWarehouseData(warehouseObj) {
      this.warehouseList = [];
      let warehouseData = await reportingService.getReportingGenericWarehouseList("post", warehouseObj);
      if (warehouseData && Array.isArray(warehouseData)) {
        this.warehouseList = warehouseData;
      } else {
        this.warehouseList = [];
      }
    },
    onChangeWarehouse(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "ware_key", "isAllWarehouseSelected", 0);
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.isAllParentClassSelected = false;
      this.isAllClassSelected = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      let parentClassObj = {
        execution_type: 1,
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.ware_key && this.reportObj.ware_key?.length > 0) {
        this.getParentClassData(parentClassObj);
      }
    },
    async getParentClassData(parentClassObj) {
      this.parentClassList = [];
      let parentClassData = await reportingService.getReportingGenericParentClassList("post", parentClassObj);
      if (parentClassData && Array.isArray(parentClassData)) {
        this.parentClassList = parentClassData;
      } else {
        this.parentClassList = [];
      }
    },
    onChangeParentClass(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "parent_class_key", "isAllParentClassSelected", 0);
      this.classList = [];
      this.reportObj.class_key = [];
      this.isAllClassSelected = false;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      let classObj = {
        execution_type: 1,
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.parent_class_key && this.reportObj.parent_class_key?.length > 0) {
        this.getClassData(classObj);
      }
    },
    async getClassData(classObj) {
      this.classList = [];
      let classData = await reportingService.getReportingGenericClassList("post", classObj);
      if (classData && Array.isArray(classData)) {
        this.classList = classData;
      } else {
        this.classList = [];
      }
    },
    async onChangeClass(selectedKeys) {
      let obj = {
        execution_type: 0,
        lcedate: this.reportObj.lcedate,
        lcsdate: this.reportObj.lcsdate,
        user_id: parseInt(this.userId),
        proj_key: this.reportObj.proj_key?.toString(),
        bu_key: this.reportObj.bu_key?.toString(),
        parent_class_key: this.reportObj.parent_class_key?.toString(),
        class_key: this.reportObj.class_key?.toString(),
        ware_key: this.reportObj.ware_key?.toString(),
        order_type: this.reportObj.order_type?.toString(),
        search_so: this.detailSearchString,
        serialized: true,
        page_number: 0,
        export: 0,
        filter_user_key: 0,
        pass: 1,
      };
      let data = await reportingService.getReportingShipmentActivityUserReport("post", obj);
      this.userData = data;
      this.handleSelectionChange(selectedKeys, "class_key", "isAllClassSelected", 0);
      this.shipMethodList = [];
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.runDisabled = false;
      let shipData = await reportingService.getGenericShipmentList("get", this.userId);
      if (shipData && Array.isArray(shipData)) {
        this.shipMethodList = shipData;
      } else {
        this.shipMethodList = [];
      }
      this.reportData = [];
      this.totalRecords = 0;
      this.clearPartShip();
    },
    onChangeOrderType(selectedKeys) {
      this.handleSelectionChange(selectedKeys, "order_type", "isAllOrderTypeSelected", "ALL");
      this.reportData = [];
      this.totalRecords = 0;
    },
    onClickSpecificPartNumber() {
      this.specificSelected = true;
    },
    async searchPartNum() {
      this.partSearchKey = this.partSearchKey?.toUpperCase();
      if (this.partSearchKey?.length > 2) {
        this.debouncedGetPartList();
      }
    },
    setEndDate() {
      let minEndDate = new Date(this.reportObj.lcsdate);
      this.minEndDate = new Date(minEndDate.getTime() + 0).toISOString().substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0).toISOString().substr(0, 10);
    },
    async getPartList() {
      this.showPartNumDetails = true;
      let SearchObj = {
        user_id: this.userId,
        search_str: this.partSearchKey,
        proj_key: this.reportObj.proj_key?.toString(),
      };
      let partResultData = await reportingService.showPartNumDetailsData("post", SearchObj, false);
      this.partResultList = partResultData?.Resultset;
    },
    async showPartDesc(item) {
      this.showPartDetails = true;
      this.partNum = item.PartNo;
      this.partDesc = item.Description;
      this.partSearchKey = item.PartNo;
      this.showPartNumDetails = false;
      this.reportObj.part_num = this.partNum;
    },
    clearPartShip() {
      this.showPartDetails = false;
      this.partSearchKey = "";
      this.partResultList = [];
      this.partNum = "";
      this.partDesc = "";
    },
    onClickRunReport(page) {
      this.page = page;
      if (this.$refs.reportForm.validate()) {
        this.quickSearch = false;
        this.detailSearch = true;
        this.detailPageNumber = 1;
        this.detailSearchString = "";
        this.reportObj.search_so = "";
        this.finalReportObj.search_so = "";
        this.finalReportObj.execution_type = this.reportObj.execution_type;
        this.finalReportObj.proj_key = this.reportObj.proj_key?.toString();
        this.finalReportObj.bu_key = this.reportObj.bu_key?.toString();
        this.finalReportObj.ware_key = this.reportObj.ware_key?.toString();
        this.finalReportObj.parent_class_key = this.reportObj.parent_class_key?.toString();
        this.finalReportObj.class_key = this.reportObj.class_key?.toString();
        this.finalReportObj.order_type = this.reportObj.order_type?.toString();
        this.finalReportObj.serialized = this.reportObj.serialized;
        this.finalReportObj.part_num = this.reportObj.part_num;
        this.finalReportObj.lcedate = Utility.inputDateFormat(this.lceDateFormattedMomentjs, "23:59:59");
        this.finalReportObj.lcsdate = Utility.inputDateFormat(this.lcsDateFormattedMomentjs, "00:00:00");
        this.reportObj.page_number = page ? page : 1;
        this.finalReportObj.page_number = this.reportObj.page_number;
        this.finalReportObj.export = this.reportObj.export;
        this.finalReportObj.pass = 2;
        this.getTableData(this.finalReportObj, "quick");
      }
    },
    onClickPagination(page) {
      if (this.detailSearchString) {
        this.onClickDetailSearch(page);
      } else {
        this.onClickRunReport(page);
      }
    },
    async exportData() {
      this.exportDialog = false;
    },
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //Wnd the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    async exportToExcel() {
      if (this.totalRecords <= 50000) {
        this.finalReportObj.export = 1;
        this.finalReportObj.pass = 2;
        let exportResult = [];
        if (!this.detailSearchString) {
          exportResult = await reportingService.getReportingShipmentActivityExportReport("post", this.finalReportObj);
        } else {
          let exportObj = {
            pass: 0,
            user_id: this.userId,
            SearchStr: this.detailSearchString,
            SearchType: this.selectedType == "1" ? "Equals" : "Contains",
            PageNumber: 1,
            export: 1,
          };
          exportResult = await reportingService.getReportingShipmentActivityDetailSearchExportReport("post", exportObj);
        }
        if (exportResult && Array.isArray(exportResult) && exportResult.length > 0) {
          exportResult.forEach((element) => {
            element.Created_Date = element.Created_Date == null ? "" : Utility.displayDateFormat(element.Created_Date);
            element.ShipBy_Date = element.ShipBy_Date == null ? "" : Utility.displayDateFormat(element.ShipBy_Date);
            element.Aloc_Date = element.Aloc_Date == null ? "" : Utility.displayDateFormat(element.Aloc_Date);
            element.Shpd_Date = element.Shpd_Date == null ? "" : Utility.displayDateFormat(element.Shpd_Date);
          });
        }
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Shipment Activity");
        const borderStyle = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        const colors = {
          primary: { type: "pattern", pattern: "solid", fgColor: { argb: "005ba8" } },
          white: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } },
        };
        //Add Header Rows
        worksheet.addRow([
          "Project",
          "Business",
          "SO Number",
          "Line No",
          "Line Type",
          "Order Type",
          "RMA",
          "Cust PO",
          "Order No",
          "Origin Number",
          "Origin SO RMA",
          "Origin PO RMA",
          "Created Date",
          "Ship By Date",
          "Aloc Date",
          "Shipped Date",
          "Company Name",
          "Address 1",
          "Address 2",
          "City",
          "State",
          "Zip Code",
          "Country",
          "Name",
          "Email",
          "Employee Name",
          "Employee ID",
          "Empl_Email",
          "Cost_Center",
          "SIte",
          "Item",
          "OEM Part",
          "Description",
          "Model",
          "PClass",
          "Class",
          "OEM",
          "Price",
          "Quantity Ordered",
          "Quantity Shipped",
          "BCN",
          "Serial No",
          "ESN",
          "ICCID",
          "RLP ID",
          "Main ID",
          "Warranty",
          "Grade",
          "Carrier",
          "Freight Billable",
          "Return Billable",
          "Expected Return SN",
          "Location",
          "Warehouse",
          "Method",
          "Origin No",
          "Origin RMA",
          "Date Received",
          "Flex Code1",
          "Flex Date1",
          "Flex Code2",
          "Flex Date2",
          "Flex Code3",
          "Flex Date3",
          "Flex Code4",
          "Flex Date4",
          "Flex Code5",
          "Flex Date5",
        ]);
        const headerStyle = {
          font: { bold: true, color: { argb: "FFFFFFFF" } },
          alignment: { horizontal: "center", vertical: "middle", wrapText: true },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF808080" } },
        };
        // Apply styles to the header rows
        worksheet.getRow(1).eachCell((cell) => {
          cell.style = { ...headerStyle, fill: colors.primary };
          cell.border = borderStyle;
        });
        //Add your data rows
        exportResult.forEach((item) => {
          const row = worksheet.addRow([
            item.Project,
            item.Business,
            item.SO_Number,
            item.Line_No,
            item.Line_Type,
            item.Order_Type,
            item.RMA,
            item.Cust_PO,
            item.Order_No,
            item.Origin_Number,
            item.Origin_SORMA,
            item.Origin_PORMA,
            item.Created_Date,
            item.ShipBy_Date,
            item.Aloc_Date,
            item.Shpd_Date,
            item.Company_Name,
            item.Addr1,
            item.Addr2,
            item.City,
            item.State,
            item.Zip_Code,
            item.Country,
            item.Name,
            item.Email,
            item.Empl_Name,
            item.Empl_ID,
            item.Empl_Email || item.employee_email,
            item.Cost_Center || item.cost_center,
            item.Site || item.site_id,
            item.Item,
            item.OEM_PartNo,
            item.Description,
            item.Model,
            item.PClass,
            item.Class,
            item.OEM,
            item.Price,
            item.Qty_Ord,
            item.Qty_Ship,
            item.BCN,
            item.Serial_No,
            item.ESN,
            item.ICCID,
            item.RLP_ID,
            item.Main_ID,
            item.Warranty,
            item.Grade,
            item.Carrier,
            item.Frt_bill,
            item.Rtn_bill,
            item.Expect_Rtn_SN,
            item.Location,
            item.Warehouse,
            item.Method,
            item.Origin_No,
            item.Origin_rma,
            item.Date_Rcvd,
            item.flex_code1,
            item.flex_data1,
            item.flex_code2,
            item.flex_data2,
            item.flex_code3,
            item.flex_data3,
            item.flex_code4,
            item.flex_data4,
            item.flex_code5,
            item.flex_data5,
          ]);
          row.eachCell({ includeEmpty: true }, (cell) => {
            //Apply borders
            cell.border = borderStyle;
          });
        });
        //Download the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), Utility.excelNewFileName("Shipment Activity"));
      } else {
        this.exportDialog = true;
        this.finishDownload();
        return true;
      }
    },
    async getTableData(reportObj, loc) {
      if (loc == "quick") {
        this.reportData = await reportingService.getReportingShipmentActivityReport("post", reportObj);
        this.detailPageNumber = 1;
        this.detailSearchString = "";
      } else {
        this.reportData = await reportingService.getReportingShipmentActivityDetailSearchReport("post", reportObj);
      }
      if (this.reportData && Array.isArray(this.reportData) && this.reportData.length > 0) {
        // Process date fields in each record
        this.reportData.forEach((element) => {
          // Convert date fields from EST to local time
          element.Created_Date = element.Created_Date == null ? "" : Utility.displayDateFormat(element.Created_Date);
          element.ShipBy_Date = element.ShipBy_Date == null ? "" : Utility.displayDateFormat(element.ShipBy_Date);
          element.Aloc_Date = element.Aloc_Date == null ? "" : Utility.displayDateFormat(element.Aloc_Date);
          element.Shpd_Date = element.Shpd_Date == null ? "" : Utility.displayDateFormat(element.Shpd_Date);
        });
        // After processing the data, set UI state variables
        this.showData = true;
        this.totalRecords = this.reportData[0].TotalRecords;
        this.totalPages = this.reportData[0].TotalPages;
      } else {
        // Handle the no data case
        this.showData = false;
        this.reportData = [];
        this.totalRecords = 0;
        this.totalPages = 0;
        this.$refs.reportForm.resetValidation();
        Utility.validateForm("reportForm", this);
        Utility.showNoDataToast("No Data Found");
      }
    },
    resetFunction() {
      // Reset the report object to its initial state
      this.reportObj = {
        lcsdate: new Date().toISOString().substr(0, 10), // Or null/default
        proj_key: [], // Use [] for multi-select, or initial value
        bu_key: [],
        ware_key: [],
        parent_class_key: [],
        class_key: [],
        lcedate: new Date(new Date().getTime()).toISOString().substr(0, 10), // Or null/default
        user_id: this.userId, // Keep user_id
        order_type: "",
        serialized: false,
      };
      // Reset dependent lists and flags
      this.businessList = [];
      this.detailSearchString = "";
      this.selectedType = "1";
      this.warehouseList = [];
      this.orderTypeList = [];
      this.parentClassList = [];
      this.specificSelected = false;
      this.disableAll = false;
      this.partResultList = [];
      this.partNum = "";
      this.partDesc = "";
      this.classList = [];
      this.shipMethodList = []; // Reset ship method list if needed
      this.isAllProjectSelected = false;
      this.isAllBusinessSelected = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.isAllClassSelected = false;
      this.isAllOrderTypeSelected = false;
      this.showPart = true;
      this.showPartDetails = false;
      this.hideSpecific = false;
      this.disableAll = false;
      // Reset part search state
      this.clearPartShip();
      // Reset validation state
      this.$refs.reportForm.resetValidation();
      // Hide results
      this.showData = false;
      this.reportData = [];
      this.totalRecords = 0;
      // Re-fetch initial data if necessary (like projects)
      this.getProjectData();
    },
    onClickDetailSearch(page) {
      this.page = page;
      let reportObj = {
        pass: 2,
        user_id: this.userId,
        SearchStr: this.detailSearchString,
        SearchType: this.selectedType == "1" ? "Equals" : "Contains",
        PageNumber: page,
        export: 0,
      };
      this.getTableData(reportObj, "detail");
    },
  },
  components: {
    breadcrumbComp,
    BackToTop,
    exportLimit,
  },
};
